import React from 'react'
import PropTypes from 'prop-types'
import { compose, withState } from 'recompose'
import { Body, Item, Title } from './layout'

class Menu extends React.Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    title: PropTypes.string,
    onRowClick: PropTypes.func.isRequired,
  }

  static defaultProps = {
    onRowClick() {},
  }

  render() {
    return (
      <Body className="color-mode-elevated">
        {this.props.title && <Title>{this.props.title}</Title>}
        {this.props.items
          .filter(({ isAllowed = true }) => isAllowed)
          .map((item, index) => {
            if (item.separation) {
              return (
                <div
                  key={index}
                  className="border-top-medium border-shade-50"
                />
              )
            }
            return (
              <a key={index} download={true} href={item.href}>
                <Item
                  onRowClick={item.onRowClick || this.props.onRowClick}
                  action={item.action}
                  renderConfirm={item.confirm}
                  icon={
                    item.icon && (
                      <item.icon className={item.className} size={16} />
                    )
                  }
                  image={item.image}
                >
                  {item.title}
                </Item>
              </a>
            )
          })}
      </Body>
    )
  }
}

export default compose(withState('itemConfirm', 'onItemConfirm', false))(Menu)
